<div
  *ngIf="user && user.role"
  class="text-right position-relative"
  fxFlex="40"
  fxFlex.xs="40"
  fxLayout.xs="row"
  fxLayoutAlign.xs="end center"
>
  <div
    fxLayout="column"
    class="btns position-absolute"
    style="cursor: pointer;"
    id="clickbox"
  >
    <ng-container [ngSwitch]="user.role.name">
      <ng-container
        *ngSwitchCase="
          ['sales_rep', 'sales_manager'].includes(user.role.name)
            ? user.role.name
            : null
        "
      >
        <div
          class="button-actions"
          [class.blue-btn]="selectorActive"
          fxLayout="row"
          fxLayoutAlign="space-around end"
          (click)="$event.stopPropagation(); selectorActive = !selectorActive"
          routerLink="/main/order-management/new-order/new/create"
          [ngStyle]="{ 'font-size': '14px' }"
        >
          <a routerLink="/main/order-management/new-order/new/create"
            >New Order</a
          >
          <div
            (click)="$event.stopPropagation(); selectorActive = !selectorActive"
          >
            <mat-divider
              [vertical]="true"
              style="margin-left: 1.2px;"
            ></mat-divider>
            <mat-icon *ngIf="!selectorActive">keyboard_arrow_up</mat-icon>
            <mat-icon *ngIf="selectorActive">keyboard_arrow_down</mat-icon>
          </div>
        </div>
        <div
          *ngIf="selectorActive"
          fxLayout="row"
          class="button-actions"
          (click)="$event.stopPropagation(); selectorActive = !selectorActive"
          routerLink="/main/quotes/create"
          fxLayoutAlign="space-around end"
          [ngStyle]="{ 'font-size': '14px' }"
        >
          <div>
            <a routerLink="/main/quotes/create"> New Quote</a>
          </div>
          <div>
            <mat-divider
              [vertical]="true"
              style="margin-left: 0.4px;"
            ></mat-divider>
            <mat-icon style="opacity : 0;">keyboard_arrow_down</mat-icon>
          </div>
        </div>
        <div
          *ngIf="selectorActive"
          fxLayout="row"
          class="button-actions"
          (click)="$event.stopPropagation(); selectorActive = !selectorActive"
          routerLink="/main/leads/create"
          fxLayoutAlign="space-around end"
          [ngStyle]="{ 'font-size': '14px' }"
        >
          <div style="margin-right: 7px;">
            <a routerLink="/main/leads/create">New Lead</a>
          </div>
          <div>
            <mat-divider
              [vertical]="true"
              style="margin-left: 1.9px;"
            ></mat-divider>
            <mat-icon style="opacity : 0;">keyboard_arrow_down</mat-icon>
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'fronter'">
        <div
          class="button-actions"
          [class.blue-btn]="selectorActive"
          fxLayout="row"
          fxLayoutAlign="space-around end"
          routerLink="/main/leads/create"
          [ngStyle]="{ 'font-size': '14px' }"
          (click)="$event.stopPropagation(); selectorActive = !selectorActive"
        >
          New Lead
          <div>
            <mat-divider
              [vertical]="true"
              style="margin-left: 1.2px;"
            ></mat-divider>
            <mat-icon>add</mat-icon>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
